import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Tabs, Tab } from '@mui/material';
import { texts } from 'utils/languages/fr';
import ExpandableList from 'components/ExpandableList/ExpandableList';
import Actions from './Actions';
import Phases from './Phases';

const treeContainerSx = {
    width: '100%',
    textAlign: 'left',
    pl: theme => theme.spacing(2),
};

const tunnelSectionSx = {
    mb: theme => theme.spacing(3),
};

const tabContentSx = {
    mt: theme => theme.spacing(1),
    width: '100%',
};

const ActiveTunnelTabs = ({ tunnelData }) => {
    const [tabValues, setTabValues] = useState(() => {
        const initialValues = {};
        Object.keys(tunnelData).forEach(tunnelType => {
            tunnelData[tunnelType].forEach(tunnel => {
                initialValues[tunnel.id] = 0;
            });
        });
        return initialValues;
    });

    const handleTabChange = tunnelId => (event, newValue) => {
        setTabValues(prev => ({
            ...prev,
            [tunnelId]: newValue,
        }));
    };

    return (
        <Box sx={treeContainerSx}>
            {['activeTunnels', 'defaultActiveTunnels'].map(tunnelType =>
                tunnelData[tunnelType].map((tunnel, tunnelIndex) => (
                    <ExpandableList
                        title={tunnel.name}
                        key={`${tunnelType}-${tunnelIndex}`}
                        sx={tunnelSectionSx}
                    >
                        <Box>
                            <Tabs
                                value={tabValues[tunnel.id]}
                                onChange={handleTabChange(tunnel.id)}
                                indicatorColor="primary"
                                textColor="primary"
                                variant="fullWidth"
                            >
                                <Tab label={texts.ACTIONS} style={{ width: '50%' }} />
                                <Tab label={texts.ETAPES} style={{ width: '50%' }} />
                            </Tabs>

                            <Box sx={tabContentSx}>
                                {tabValues[tunnel.id] === 0 && tunnel.actions.length > 0 && (
                                    <Actions tunnel={tunnel} />
                                )}
                                {tabValues[tunnel.id] === 1 && <Phases tunnel={tunnel} />}
                            </Box>
                        </Box>
                    </ExpandableList>
                ))
            )}
        </Box>
    );
};

ActiveTunnelTabs.propTypes = {
    tunnelData: PropTypes.shape({
        activeTunnels: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.string.isRequired,
                name: PropTypes.string.isRequired,
                actions: PropTypes.array.isRequired,
            })
        ).isRequired,
        defaultActiveTunnels: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.string.isRequired,
                name: PropTypes.string.isRequired,
                actions: PropTypes.array.isRequired,
            })
        ).isRequired,
    }).isRequired,
};

export default ActiveTunnelTabs;
